import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../css/others/Card.css";
import "../css/others/Table.css";
import Card from "../Reusablecomponents/Card";
import BackButton from "../Reusablecomponents/BackButton";
import { apiCall } from "../main/ApiCall";
import IconComponent from "../Reusablecomponents/IconComponent";
import { ProjectDetail } from '../interFaces/interfaces';
const CampaignAndProjectHistroyDetails: React.FC = () => {
  const [campaignProjectHistory, setCampaignProjectHistory] = useState<ProjectDetail | null>(null);
  const { campaignId, projectId } = useParams<{ campaignId: string; projectId: string }>();
  useEffect(() => {
    if (!projectId || !campaignId) return;
    apiCall("get", `/api/campaign-projects/history/${campaignId}/${projectId}`)
      .then((response) => {
        const projectData = Array.isArray(response) ? response[0] : response;
        setCampaignProjectHistory(projectData);
      })
      .catch((error) => {
        console.error("Error fetching project details:", error);
      });
  }, [campaignId, projectId]);
  const includedFields = ["campaignName", "campaignId", "accountId", "accountName", "businessUnit", "projectId", "projectName", "projectManagerName", "deliveryManagerName", "deliveryHeadName", "teamSize", "deliveryModel", "billingType", "qualityConsultantName", "qualityManagerName", "estimationModel", "devOps_CICDtoolname", "testingToolName", "codequalityToolName", "testManagerName", "architect", "technicalLeadName", "customerLocation", "projectLocation", "projectLifeCycle", "risk", "targetML", "remarkByQC", "remarkByAuditTeam", "createdDate", "createdBy", "projectStartDate", "projectEndDate", "projectManagerEmail", "deliveryManagerEmail", "deliveryHeadEmail", "qualityConsultantEmail", "qualityManagerEmail", "testManagerEmail", "technicalLeadEmail", "auditorEmployeeId", "primaryAuditorName", "secondaryAuditorName", "campaignStartDate", "campaignEndDate", "assignedCheckList", "updatedDate", "remarkByAdmin", "updatedBy"];
  return (
    <div className="container">
      <h1 className="title">Campaign Project History Details</h1>
      {!campaignProjectHistory ? (
        <p className="spinner">Loading project history details...</p>
      ) : (
        <div className="grid">
          {Object.entries(campaignProjectHistory).map(([key, value]) => {
            if (!includedFields.includes(key)) return null;
            const label = key
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (str) => str.toUpperCase())
              .replace("Dev Ops CICDtoolname", "DevOps/CICD Tool")
              .replace("Codequality Tool Name", "Code Quality Tool");
            const displayValue = value === null || value === undefined || value === "" ? "N/A" : value;
            return (
              <Card key={key} label={label} value={displayValue} icon={<IconComponent name={key} className="icon" />}/>
            );
          })}
        </div>
      )}
      <div className="buttons">
        <BackButton className="back-button2" label="Back" />
      </div>
    </div>
  );
};
export default CampaignAndProjectHistroyDetails;